<script>
  import { onMount } from "svelte";
  onMount(() => {});
</script>

<div class="legend">
  <span class="legend-label">Low</span>
  <div class="legend-gradient"></div>
  <span class="legend-label">High</span>
</div>

<style>
  .legend {
    display: flex;
    align-items: center;
    margin: 10px;
    position: absolute;
    top: 40px;
    opacity: 0;
    right: -10px;
    z-index: 1000;
    margin: 10px;
    color: white;
  }

  .legend-label {
    margin: 0 10px;
  }

  .legend-gradient {
    height: 20px;
    width: 200px;
    background: linear-gradient(to right, #af0505, yellow, green);
    border: 1px solid #000;
  }
</style>
